import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { ApiService } from '../../shared/services';

@Injectable({
  providedIn: 'root'
})
export class ClientMasterService {

  constructor(private http: HttpClient,
    private apiService: ApiService) {

     }
  
     createClient(body:any):Observable<any> {
      return this.apiService.post(`CompanyProfile/ClientCompanyProfile`,body);
    }
    public onClientNameCheck(companyName: string): Observable<any> {
      return this.apiService.get(`CompanyProfile/ClientNameDuplicateCheck?clientName=${companyName}`);
    }
}
